import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {
  Button,
  Form,
  FormGroup,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap';
import { injectIntl } from 'react-intl';

import { APIgetCollection } from '../../api/Collections';

import CollectionsTree from './Tree';
import ProcessingSpinner from '../ProcessingSpinner';

import ErrorBoundary from '../ErrorBoundary';
import CollectionSelectCollectionMessage from './SelectCollectionMessage';

class CollectionSelectModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      initialized: false,
      collectionUuid: null,
      loading: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSelectCollection = this.handleSelectCollection.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
  }

  componentDidMount() {
    this.initSelectedCollection();
  }

  initSelectedCollection() {
    const { selectedCollectionUuid } = this.props;
    if (selectedCollectionUuid) {
      this.handleChange(selectedCollectionUuid);
    }
    this.setState({ initialized: true });
  }

  handleChange(value) {
    this.setState({ collectionUuid: value });
  }

  handleSelectCollection() {
    const { collectionUuid } = this.state;
    const {
      handleCollectionSelect,
      handleClose,
    } = this.props;

    if (!collectionUuid) {
      return;
    }

    this.setState({ loading: true });
    APIgetCollection(collectionUuid).then((response) => {
      const { data } = response;
      handleCollectionSelect(_.pick(data, [
        'uuid',
        'name',
        'featured_file',
        'files',
        'allow_changes',
        'capabilities',
        'user',
        'access_description',
        'access_icon',
        'spread_permissions',
        'spread_permissions_always',
      ]));
      handleClose();
    });
  }

  handleKeyPress(e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      this.handleSelectCollection();
    }
  }

  render() {
    const {
      intl,
      enableAddNew,
      enableAllCollections,
      onlyOpenCollections,
      multiSelect,
      selectedCollectionUuid,
      handleClose,
      smartCollectionsRestrict,
      showSmartSection,
    } = this.props;
    const {
      initialized,
      collectionUuid,
      loading,
    } = this.state;

    if (!initialized && !collectionUuid && selectedCollectionUuid) {
      return null;
    }

    return (
      <ErrorBoundary>
        <ModalHeader toggle={handleClose} className="modal-header-center">
          {intl.formatMessage({ defaultMessage: 'Select Collection' })}
        </ModalHeader>
        <ModalBody style={{ overflow: 'visible' }}>
          <Form
            className="select-collection-form"
            onKeyPress={this.handleKeyPress}
          >
            <FormGroup>
              <CollectionSelectCollectionMessage enableAddNew={enableAddNew} />
              <CollectionsTree
                selectedCollections={collectionUuid ? [collectionUuid] : []}
                enableMyCollections={false}
                enableAddNew={enableAddNew}
                enableAllCollections={enableAllCollections}
                onlyOpenCollections={onlyOpenCollections}
                multiSelect={multiSelect}
                onChange={(selectedUuids) => {
                  if (selectedUuids.length > 0) {
                    this.setState({ collectionUuid: selectedUuids[0] });
                  } else {
                    this.setState({ collectionUuid: null });
                  }
                }}
                smartCollectionsRestrict={smartCollectionsRestrict}
                showSmartSection={showSmartSection}
              />
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter className="justify-r">
          <div className="buttons-group">
            <Button
              color="primary"
              disabled={loading || !collectionUuid}
              onClick={this.handleSelectCollection}
            >
              <ProcessingSpinner show={loading} />
              {intl.formatMessage({ defaultMessage: 'Select Collection' })}
            </Button>
          </div>
        </ModalFooter>
      </ErrorBoundary>
    );
  }
}

CollectionSelectModal.propTypes = {
  intl: PropTypes.object.isRequired,
  enableAddNew: PropTypes.bool,
  enableAllCollections: PropTypes.bool,
  onlyOpenCollections: PropTypes.bool,
  multiSelect: PropTypes.bool,
  selectedCollectionUuid: PropTypes.string,
  handleClose: PropTypes.func.isRequired,
  handleCollectionSelect: PropTypes.func.isRequired,
  smartCollectionsRestrict: PropTypes.bool,
  showSmartSection: PropTypes.bool,
};

CollectionSelectModal.defaultProps = {
  enableAddNew: false,
  enableAllCollections: false,
  onlyOpenCollections: false,
  multiSelect: false,
  selectedCollectionUuid: null,
  smartCollectionsRestrict: null,
  showSmartSection: true,
};

export default injectIntl(CollectionSelectModal);
